// this file is generated by update_shopify_store_data.py at 2026-05-26 20:29:10.736212
var courses = [
    {
        "course_id": "35D9D597-27BB-F011-99A0-005056A78EAA",
        "course_version": 1,
        "name": "Planetary Health: Foundations for a Healthier World",
        "course_type": 1,
        "author_information": "Carol Zigler, DNP, FNP-C, APHN-BC",
        "description": "Planetary Health explores how climate change and environmental shifts directly impact our health\u2014from the air we breathe to the food we eat and the diseases we face. This interactive course breaks down complex issues into real-world examples, showing how extreme heat, air pollution, and ecological changes are not just environmental problems, but urgent human ones. You\u2019ll learn how communities are responding, why global frameworks like the S\u00e3o Paulo Declaration matter, and what actions can lead to a healthier, more sustainable future for all.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ol>Define the concept of Planetary Health and explain its relevance to clinical practice and public well-being. </ol>\r\n    <ol>Identify key environmental changes (e.g., climate change, pollution) and describe their direct and indirect impacts on human health. </ol>\r\n        <ol>Analyze real-world case examples that illustrate the connection between environmental factors and patient health outcomes. </ol>\r\n            <ol>Describe individual, clinical, and community-level strategies that promote both environmental sustainability and human health.\r\n            </ol>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C15CE9E2-F6D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Planetary Health: Foundations for a Healthier World",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3612D096-F5D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing: Planetary Health: Foundations for a Healthier World",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Leadership Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 0.75 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 0.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];